/** Same normalization as ShiftDetailModal for actual_state. */
export function normalizeActualState(raw) {
  return String(raw || "")
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, "_");
}

/**
 * Mirrors ShiftDetailModal Overview "Check in time" status-badge (not shift assignment status).
 * @returns {{ label: string, badgeClass: string }}
 */
export function checkInTimeStatusFromManageRow(row) {
  const actualStateNorm = normalizeActualState(
    row?.actualState ?? row?.actual_state ?? "",
  );
  const actualsSubmitted =
    !!actualStateNorm &&
    actualStateNorm !== "not_submitted" &&
    actualStateNorm !== "notsubmitted";

  if (actualsSubmitted) {
    const signoffNorm = normalizeActualState(
      row?.signoffState ?? row?.signoff_state ?? "",
    );
    if (
      signoffNorm === "pending_signoff_review" ||
      signoffNorm === "pendingsignoffreview"
    ) {
      return { label: "Pending signoff review", badgeClass: "pending-review" };
    }
    return { label: "Signoff completed", badgeClass: "signoff-complete" };
  }

  const checkoutRaw = row?.checkoutDate ?? row?.checkout_date;
  if (checkoutRaw && !Number.isNaN(new Date(checkoutRaw).getTime())) {
    return { label: "Pending signoff", badgeClass: "pending" };
  }

  const checkinRaw = row?.checkinDate ?? row?.checkin_date;
  if (checkinRaw && !Number.isNaN(new Date(checkinRaw).getTime())) {
    return { label: "Checked in", badgeClass: "checked-in" };
  }

  const startRaw = row?.startDate ?? row?.start_date;
  if (startRaw) {
    const start = new Date(startRaw);
    if (!Number.isNaN(start.getTime())) {
      const now = new Date();
      if (start > now) {
        return { label: "Future", badgeClass: "future" };
      }
      return { label: "Late", badgeClass: "late" };
    }
  }

  return { label: "Pending signoff", badgeClass: "pending" };
}
